export default {
  "settings.title": "Settings",
  "settings.subtitle": "Laundry data, account security and dashboard language",

  "settings.section.laundry": "Laundry data",
  "settings.section.laundryDesc": "The current approved data and any modification request under review",
  "settings.section.security": "Account security",
  "settings.section.securityDesc": "Change the laundry account password",
  "settings.section.language": "Dashboard language",
  "settings.section.languageDesc": "The dashboard display language and interface direction",

  "settings.approved.title": "Approved data",
  "settings.approved.badge": "Approved data",
  "settings.approvedNote": "This is the current approved data used across the dashboard.",
  "settings.requestEdit": "Request data change",

  "settings.field.name": "Laundry name",
  "settings.field.description": "Description",
  "settings.field.logo": "Image or logo",
  "settings.field.phone": "Phone number",
  "settings.field.address": "Laundry address on the map",
  "settings.field.coverage": "Districts covered by the laundry",
  "settings.field.workingHours": "Working hours",
  "settings.field.normalDuration": "Normal execution duration",
  "settings.field.urgentDuration": "Urgent execution duration",

  "settings.value.notSet": "Not defined yet",
  "settings.value.currentLogo": "Current logo",
  "settings.value.newLogo": "New logo",
  "settings.unit.hours": "hours",
  "settings.coverage.none": "No districts selected",
  "settings.address.notSet": "No address defined yet",
  "settings.duration.scope": "The durations apply to the whole laundry and start once it actually receives the order.",

  "settings.mod.title": "Change request status",
  "settings.mod.status.label": "Request status",
  "settings.mod.status.under_review": "Under review",
  "settings.mod.status.approved": "Approved",
  "settings.mod.status.rejected": "Rejected",
  "settings.mod.underReviewNote": "The change request is awaiting an admin decision; the current approved data stays in use.",
  "settings.mod.approvedNote": "The request was approved and the new values were adopted by the system.",
  "settings.mod.rejectedNote": "The change request was rejected; the previous data is still in effect.",
  "settings.mod.noneTitle": "No change request",
  "settings.mod.noneText": "The data shown is the current approved data.",
  "settings.mod.rejectionReason": "Rejection reason",
  "settings.mod.submittedAt": "Submitted at",
  "settings.mod.changesTitle": "Requested changes",
  "settings.mod.noChanges": "No recorded changes in this request.",
  "settings.mod.approvedChangesTitle": "What was approved",
  "settings.mod.col.field": "Field",
  "settings.mod.col.current": "Current approved value",
  "settings.mod.col.requested": "Requested value",
  "settings.mod.col.previous": "Previous value",
  "settings.mod.col.approvedValue": "New approved value",
  "settings.mod.eligibilityNote": "You can't submit a new change request until the current one is reviewed.",

  "settings.form.title": "Request data change",
  "settings.form.desc": "Edit the fields you need, then send the request for admin review.",
  "settings.form.basic": "Basic data",
  "settings.form.addressCoverage": "Address & coverage",
  "settings.form.hours": "Working hours",
  "settings.form.durations": "Execution durations",
  "settings.form.name": "Laundry name",
  "settings.form.description": "Description",
  "settings.form.logo": "Image or logo",
  "settings.form.phone": "Phone number",
  "settings.form.city": "City",
  "settings.form.district": "District",
  "settings.form.street": "Street",
  "settings.form.building": "Building number",
  "settings.form.coverage": "Districts covered by the laundry",
  "settings.form.coverageHint": "Choose districts from the operational districts available in the laundry's city.",
  "settings.form.fromTime": "From",
  "settings.form.toTime": "To",
  "settings.form.normalHours": "Normal duration (hours)",
  "settings.form.urgentHours": "Urgent duration (hours)",
  "settings.form.durationHint": "Durations apply to the whole laundry and start once the laundry actually receives the order.",
  "settings.form.addressHint": "Set the district, street and building number to place the address on the map.",
  "settings.form.mapPreview": "Location preview on the map",
  "settings.form.submit": "Send change request",
  "settings.form.cancel": "Cancel",
  "settings.form.note": "Changes are sent to the admin for review, and the current data stays in effect until approval.",
  "settings.form.error.name": "Laundry name is required",
  "settings.form.error.description": "Description is required",
  "settings.form.error.phone": "Phone number is required",
  "settings.form.error.phoneFormat": "Enter a valid phone number",
  "settings.form.error.duration": "Enter a positive numeric duration",
  "settings.form.error.noChanges": "The entered values match the current data, so no change request was sent.",
  "settings.form.error.submit": "Could not send the change request. Please try again.",
  "settings.form.highlightDurations": "The duration fields are highlighted below.",

  "settings.image.choose": "Choose logo",
  "settings.image.replace": "Replace logo",
  "settings.image.remove": "Remove chosen logo",
  "settings.image.none": "No logo added",
  "settings.image.hint": "Choosing a new logo replaces the current one after admin approval.",
  "settings.image.tooLarge": "File is larger than the allowed limit ({size} MB).",
  "settings.image.wrongType": "Unsupported file type.",

  "settings.toast.submitted": "Change request sent for review",
  "settings.toast.password": "Password changed",

  "settings.password.title": "Change password",
  "settings.password.desc": "Change the password used to sign in to the dashboard.",
  "settings.password.current": "Current password",
  "settings.password.new": "New password",
  "settings.password.confirm": "Confirm new password",
  "settings.password.submit": "Change password",
  "settings.password.submitting": "Changing…",
  "settings.password.show": "Show",
  "settings.password.hide": "Hide",
  "settings.password.error.required": "Please fill in all password fields",
  "settings.password.error.mismatch": "New password and confirmation do not match",
  "settings.password.error.minLength": "Password must be at least {{count}} characters",
  "settings.password.error.wrongCurrent": "Current password is incorrect",
  "settings.password.error.generic": "Could not change the password. Please try again.",
  "settings.password.successNote": "The password change takes effect immediately without admin approval.",
  "settings.password.policyNote": "The system password policy applies.",

  "settings.lang.current": "Current language",
  "settings.lang.ar": "العربية",
  "settings.lang.en": "English",
  "settings.lang.arDesc": "Arabic text with right-to-left direction",
  "settings.lang.enDesc": "English text with left-to-right direction",
  "settings.lang.selected": "Selected",
  "settings.lang.note": "The change covers all dashboard pages plus loading, empty, error and success messages, while keeping the current page and unsubmitted inputs.",

  "settings.error": "Could not load settings",
  "settings.demoNote": "This is a preview with demo data."
};